<template>
  <NewAuction v-if="store.action == 'newauction'"></NewAuction>
  <EditAuction v-if="store.action == 'editauction'"></EditAuction>
  <HostAuction v-if="store.action == 'hostauction'"></HostAuction>
</template>
<script setup>
import NewAuction from "@/components/auctioneer/setup/NewAuction.vue";
import EditAuction from "@/components/auctioneer/setup/EditAuction.vue";
import HostAuction from "@/components/auctioneer/host/HostAuction.vue";
import { useStore } from "@/store/index";
const store = useStore();
</script>
